import React from "react";
import LandingRight from "./LandingRight";

function Landing() {
  return (
    <div className="landing--container">
      <LandingRight />
    </div>
  );
}

export default Landing;
